module.exports = __webpack_public_path__ + "static/media/logout.eea9ae9d.svg";